<template>
  <div class="wechat-share-setting">
    <div class="title">
      <div class="text">{{ $t(`${i18nPrefix}.label.wechatShareSettings`) }}</div>
      <el-switch
        v-model="wechatShareConfig.isActivated"
        class="switch"
        active-color="#13ce66"
        active-value="1"
        inactive-value="0"
      />
    </div>
    <div class="tip-msg">{{ weChatTipMsgKey ? $t(weChatTipMsgKey) : $t(`${i18nPrefix}.label.tipMessage`) }}</div>
    <div class="logo-group">
      <div class="title">{{ $t(`${i18nPrefix}.label.wechatShareLogo`) }}</div>
      <img class="share-img" :src="previewFile">
      <div class="img-selector">
        <div class="select-file-btn" @click="handleFileSelectBtnClick">{{$t(`${i18nPrefix}.label.selectFile`) }}</div>
        <div class="file-name">{{ wechatShareImgFile?.name || $t(`${i18nPrefix}.label.noSelectFile`) }}</div>
        <input ref="fileSelector" class="file-selector" type="file" :accept="acceptPhotoFileTypeList.join(',')" @change="handleFileSelectorChange"/>
      </div>
    </div>
    <div class="wechat-share-info">
      <el-input v-model="wechatShareConfig.title" class="share-info-input" :placeholder="$t(`${i18nPrefix}.label.wechatShareTitle`)"></el-input>
      <el-input v-model="wechatShareConfig.description" type="textarea" class="share-info-input desc" :placeholder="$t(`${i18nPrefix}.label.wechatShareDesc`)"></el-input>
      <el-input v-model="wechatShareConfig.momentTitle" class="share-info-input" :placeholder="$t(`${i18nPrefix}.label.wechatShareMomentTitle`)"></el-input>
    </div>
  </div>
</template>

<script>
import { addQueryInPath, imageToBase64 } from '@/utils/common'

export default {
  props: {
    data: {
      required: true
    },
    weChatTipMsgKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.company.customLandingPage',
      openWechatShare: false,
      acceptPhotoFileTypeList: ['image/png', 'image/jpeg', 'image/jpg'],
      wechatShareImgFile: null,
      wechatShareImg: null,
      wechatShareConfig: {
        isActivated: '0',
        title: null,
        description: null,
        momentTitle: null,
        logo: null,
        logoFileName: null,
        logoFileB64: null
      }
    }
  },
  computed: {
    previewFile () {
      if (this.wechatShareImgFile) {
        return this.wechatShareConfig.logo
      }
      return this.$DjangoBaseUrl(addQueryInPath(this.wechatShareConfig.logo, { file_time_stamp: new Date().valueOf() }))
    }
  },
  created () {
  },
  methods: {
    handleFileSelectBtnClick () {
      this.$refs.fileSelector.click()
    },
    async handleFileSelectorChange () {
      const file = this.$refs.fileSelector.files[0]
      if (!file) {
        return
      }
      if (!this.acceptPhotoFileTypeList.includes(file.type)) {
        this.$message.error({
          showClose: true,
          message: this.$t(`${this.i18nPrefix}.message.wrongPhotoFileType`)
        })
        return true
      }
      this.wechatShareImgFile = file
      const imgBase64 = await imageToBase64(window.URL.createObjectURL(file))
      this.wechatShareConfig.logo = imgBase64
      this.wechatShareConfig.logoFileName = file.name
      this.wechatShareConfig.logoFileB64 = imgBase64
    },
    submit () {
      const {
        description,
        isActivated,
        momentTitle,
        title,
        logo,
        logoFileName,
        logoFileB64
      } = this.wechatShareConfig

      return {
        title,
        logo,
        description,
        is_activated: isActivated,
        moment_title: momentTitle,
        logo_file_name: logoFileName,
        logo_file_b64: logoFileB64
      }
    }
  },
  watch: {
    data: {
      handler () {
        if (!this.data) {
          return
        }
        const wechatShareConfig = this.wechatShareConfig
        const data = this.data
        wechatShareConfig.description = data.description
        wechatShareConfig.isActivated = data.is_activated
        wechatShareConfig.momentTitle = data.moment_title
        wechatShareConfig.title = data.title
        wechatShareConfig.logo = data.logo
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-share-setting {
  padding: 20px 0;

  .title {
    display: flex;

    .text {
      font-size: 20px;
    }

    .switch {
      margin-left: auto;
    }
  }

  .tip-msg {
    margin-top: 20px;
    color: #666;
  }

  .logo-group {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .title {
      width: 130px;
    }

    .share-img {
      margin-left: 10px;
      height: 100px;
      width: 100px;
      border: 1px solid #ddd;
      background-color: #f7f7f7;
      background-size: 100%;
      cursor: pointer;
    }

    .img-selector {
      margin-left: 20px;
      display: flex;

      .select-file-btn {
        height: 30px;
        line-height: 30px;
        padding: 0 8px;
        border: 1px solid #767676;
        border-radius: 2px;
        background-color: #efefef;
        cursor: pointer;
      }

      .file-name {
        margin-left: 8px;
        line-height: 30px;
      }

      .file-selector {
        display: none;
      }
    }
  }

  .wechat-share-info {
    .share-info-input {
      margin-top: 20px;
      ::v-deep .el-input__inner {
        border: 1px solid #ddd;
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        padding: 0 20px;
        font-size: 12px;
      }

      &.desc {
        ::v-deep .el-textarea__inner {
          background: #f7f7f7;
          height: 70px;
          padding: 0 20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
